import { Component, OnInit, Inject } from '@angular/core';
import { ContatoAnexo } from 'src/app/models/contato-anexo';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { EnumService } from 'src/app/services/enum.service';
import { ContatoAnexoService } from 'src/app/services/contato-anexo.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from 'src/app/services/global.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { TipoArquivo } from 'src/app/models/enum';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-contato-anexo-modal',
  templateUrl: './cadastrar-contato-anexo-modal.component.html',
  styleUrls: ['./cadastrar-contato-anexo-modal.component.scss']
})
export class CadastrarContatoAnexoModalComponent implements OnInit {
  idContatoAnexo;
  idContato;
  contatoAnexo = new ContatoAnexo();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  public config: PerfectScrollbarConfigInterface = {};
  selectedFile: File;
  nomeArquivoBanco = '';
  origem = 0;
  statusSelecionado;

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService,
    private contatoAnexoService: ContatoAnexoService, private enumService: EnumService,
    private router: Router, public dialog: MatDialog,
    private globalService: GlobalService, private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService, public dialogRef: MatDialogRef<CadastrarContatoAnexoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private arquivoService: ArquivoService) {
    this.idContatoAnexo = data.id;
    this.idContato = data.idContato;
    this.statusSelecionado = data.statusSelecionado;
  }

  ngOnInit() {
    if (this.idContatoAnexo) {
      this.editando = true;
      this.buscarContatoAnexo();
    } else {
      this.contatoAnexo = new ContatoAnexo();
      this.contatoAnexo.arquivo = '';
      this.atualizaDadosContatoAnexo();
    }
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarContatoAnexo() {

    this.carregandoService.mostra('buscaContatoAnexo');

    this.contatoAnexoService.consultarPorIdContatoAnexo(this.idContatoAnexo).subscribe(contatoAnexo => {
      this.contatoAnexo = contatoAnexo;
      this.nomeArquivoBanco = this.contatoAnexo.arquivo;
      this.atualizaDadosContatoAnexo();
    }, (erro) => {
      this.carregandoService.esconde('buscaContatoAnexo');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosContatoAnexo() {

    this.carregando = false;

    this.carregandoService.esconde('buscaContatoAnexo');
  }

  salvar() {
    this.carregandoService.mostra('salvaContatoAnexo');

    this.contatoAnexo.idContato = this.idContato;

    const dados = new FormData();
    if (this.selectedFile) {
      dados.append('arquivo_consulta', this.selectedFile);
      dados.append('arqui[arquivo]', this.selectedFile.name);
    } else {
      dados.append('arqui[arquivo]', this.contatoAnexo.arquivo);
    }

    dados.append('arqui[id]', this.contatoAnexo.id ? this.contatoAnexo.id.toString() : '0');
    dados.append('arqui[descricao]', this.contatoAnexo.descricao);
    dados.append('arqui[idContato]', this.idContato);
    dados.append('arqui[origem]', this.origem.toString());
    dados.append('arqui[idAnexo]', this.contatoAnexo.idAnexo ? this.contatoAnexo.idAnexo.toString() : '0');

    this.contatoAnexoService.salvar(dados).subscribe(() => {
      this.notificacaoService.sucesso('Anexo salvo com sucesso!!!');
      this.carregandoService.esconde('salvaContatoAnexo');
      this.dialogRef.close(true);

    }, (erro) => {
      this.carregandoService.esconde('salvaContatoAnexo');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {

  }

  fechar() {
    this.dialogRef.close();
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  baixarArquivo() {

    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(this.idContatoAnexo, TipoArquivo.Integrador).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, this.nomeArquivoBanco);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });

  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.contatoAnexo.arquivo = '';
  }

}
